import { SUPPORT_CONTENT, type TicketErrorKey } from '../../content/sections/support.js';
import { ApiError } from '../../lib/http.js';

/* Classifica o erro num código estável — o texto mora só no catálogo bilíngue
   (`content/sections/support.ts`). */
function ticketErrorKey(err: unknown): TicketErrorKey {
  if (err instanceof ApiError) {
    switch (err.code) {
      case 'not_found':
        return 'notFound';
      case 'network':
        return 'network';
      default:
        return 'default';
    }
  }
  return 'unexpected';
}

/**
 * Mensagem traduzida para erros de operação em tickets (atender/fechar).
 *
 * O parâmetro `errors` é o mapa do locale corrente (`useSupportContent().ticketErrors`); o
 * default pt-BR existe para chamadores fora de componente (testes unitários).
 */
export function ticketErrorMessage(
  err: unknown,
  errors: Readonly<Record<TicketErrorKey, string>> = SUPPORT_CONTENT['pt-BR'].ticketErrors,
): string {
  return errors[ticketErrorKey(err)];
}
